import { render, staticRenderFns } from "./BullDiseaseScreening.vue?vue&type=template&id=166816ae&scoped=true&"
import script from "./BullDiseaseScreening.vue?vue&type=script&lang=js&"
export * from "./BullDiseaseScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166816ae",
  null
  
)

export default component.exports